import { render, staticRenderFns } from "./GeneratorLinkPay.vue?vue&type=template&id=2334c998&scoped=true&"
import script from "./GeneratorLinkPay.vue?vue&type=script&lang=js&"
export * from "./GeneratorLinkPay.vue?vue&type=script&lang=js&"
import style0 from "./GeneratorLinkPay.vue?vue&type=style&index=0&id=2334c998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2334c998",
  null
  
)

export default component.exports